var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useReport } from '@tencent/dz-report';
import { MenuItemType } from '../../../const';
export var useReportService = function (content) {
    var report = useReport();
    var moduleParams = {
        module_value: content,
        module_type: 'quick_consult',
        module_chinese_type: '自助咨询',
    };
    var menuExposure = function () {
        report.exposure(__assign(__assign({}, moduleParams), { element_chinese_type: '快捷咨询', element_id: content, element_type: 'quick_consult', element_content: content }));
    };
    var getReportParams = function (params) {
        var menu = params.menu, index = params.index;
        switch (menu.item_type) {
            case MenuItemType.phone:
                return {
                    element_chinese_type: '智能电话',
                    element_id: index + "^" + menu.item_title,
                    element_type: 'phone_button',
                    element_content: menu.item_id + "^" + menu.item_content,
                };
            case MenuItemType.consult:
                return {
                    element_chinese_type: '快捷回复',
                    element_id: index + "^" + menu.item_title,
                    element_type: 'quick_reply',
                    element_content: menu.item_content,
                };
            case MenuItemType.form:
                return {
                    element_chinese_type: '表单按钮',
                    element_id: index + "^" + menu.item_title,
                    element_type: 'form_button',
                    element_content: menu.item_title,
                };
            case MenuItemType.goWeb:
                return {
                    element_chinese_type: '去官网',
                    element_id: index + "^" + menu.item_title,
                    element_type: 'go_website',
                    element_content: menu.item_content,
                };
            default:
                return {};
        }
    };
    var menuClick = function (params) {
        report.click(__assign(__assign({}, moduleParams), getReportParams(params)));
    };
    return {
        menuExposure: menuExposure,
        menuClick: menuClick,
        moduleParams: moduleParams,
    };
};
